import type { SVGProps } from 'react';
const SvgBluetoothConnected = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#bluetooth_connected_svg__a)">
      <path
        fill="currentColor"
        d="m7 12-2-2-2 2 2 2 2-2Zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29ZM13 5.83l1.88 1.88L13 9.59V5.83Zm1.88 10.46L13 18.17v-3.76l1.88 1.88ZM19 10l-2 2 2 2 2-2-2-2Z"
      />
    </g>
    <defs>
      <clipPath id="bluetooth_connected_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBluetoothConnected;
